import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { AgGridReact } from 'ag-grid-react';
import { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Box, Button, Card, Flex, Grid, GridItem, Heading } from '@chakra-ui/react';
import admin from '../../../api/admin';
import { GetProjectMediaResponse } from '../../../models/admin-api/dto';
import DocViewer, { DocViewerRenderers, IDocument } from "react-doc-viewer";
import { observer } from 'mobx-react';
import { getFileExtension } from '../../../helpers/sasKeyHelper';


const ExternalAssetAttachmentList = (props: any) => {


    const [isLoading, setIsLoading] = React.useState(false);
    const [assetMedia, setAssetMedia] = React.useState([]);
    const [selectedMediaUrl, setSelectedMediaUrl] = React.useState<IDocument[]>([]);
    const [viewer, setViewer] = React.useState<string>("DocViewer");

    const colDefs = [
        { headerName: "Name", field: "name", flex: 2 },
        { headerName: "Type", field: "type", flex: 1, enableRowGroup: true },
    ];


    const switchViewer = (selectedMediaUrl) => {
        const ext = getFileExtension(selectedMediaUrl);

        const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg', 'tiff', 'docx'];

        if (imageExtensions.includes(ext)) {
            setViewer("DocViewer")
        }
        else {
            setViewer("Native")
        }

    }

    const handleOnSelectAsset = (e: any) => {

        if (e) {
            console.log(e);
            var assetImage = [{ uri: e.data.url }];
            setSelectedMediaUrl(assetImage)
            switchViewer(e.data.url);
        }
        else {
            setSelectedMediaUrl([])
        }
    }

    const getAssetmedia = (assetId: number) => {

        let password = props.password;

        if (process.env.REACT_APP_ASSET_INTEGRATION_MODULE == 'true') {
            password = 'password123';
        }


        setIsLoading(true);
        admin.Assets.GetAssetMediaViewer(assetId, props.sharedProjectId, password).then(
            (res: GetProjectMediaResponse) => {
                setAssetMedia(res.result);
                setIsLoading(false);
            },
            (error) => {
                alert('Error Retrieving Asset Media!' + error);
                setIsLoading(false);
            }
        );


    }

    useEffect(() => {

        if (props.assetId !== undefined) {
            getAssetmedia(props.assetId);
        }
        else {
            alert("Missing Asset ID!")
        }
    }
        , [props.assetId]);

    return (
        <>


            <Grid templateColumns="repeat(3, 1fr)" gap="1">
                <GridItem height={500} colSpan={1.5} padding={0} >
                    <div
                        className="ag-theme-quartz" // applying the grid theme
                        style={{ height: 500 }} // the grid will fill the size of the parent container
                    >
                        <AgGridReact
                            rowData={assetMedia}
                            columnDefs={colDefs as any}
                            onRowClicked={handleOnSelectAsset}
                            rowSelection={'single'}
                        />
                    </div>
                </GridItem>
                {selectedMediaUrl && selectedMediaUrl[0] ?
                    <GridItem colSpan={2} height={500} >

                        {viewer == "DocViewer" ? (
                            <>
                                <DocViewer config={{
                                    header: {
                                        disableHeader: true,
                                        disableFileName: true,
                                        retainURLParams: false
                                    }
                                }} pluginRenderers={DocViewerRenderers} documents={selectedMediaUrl} />
                            </>
                        ) : (

                            <iframe src={selectedMediaUrl[0]?.uri!} style={{ width: "100%", height: 500, border: "none", display: isLoading ? "none" : "block" }} title="Document Preview" />

                        )}

                        <>





                        </>
                    </GridItem> : <></>}
            </Grid>


        </>
    )
}

ExternalAssetAttachmentList.propTypes = {
    assetId: PropTypes.any,
    showUpload: PropTypes.any,
    projectId: PropTypes.any,
    sharedProjectId: PropTypes.any,
    password: PropTypes.any
}

export default observer(ExternalAssetAttachmentList)